import { Injectable } from '@angular/core';
import { BuildSearchFilter } from '@greco/ngx-filters';

@Injectable({ providedIn: 'any' })
export class BookingsSearchFilter extends BuildSearchFilter('BookingsSearchFilter', {
  properties: ['event.title', 'bookingOption.title', 'user.displayName', 'user.email', 'user.contactEmail'],
  propertyLabels: ['Event Title', 'Booking Option', 'User Name', 'User Email'],
}) {}
